import type { VoidFunctionComponent } from 'react';

import { FormLabel, icons } from '../../../../../../generic';
import TooltipIcon from '../../../../../../generic/TooltipIcon';

import styles from './Option.module.less';

const tooltipText = (
  <div className={styles.tooltipText}>
    Save your current options configuration for quick reuse in other reports.
  </div>
);

export const SavedOptionsLabel: VoidFunctionComponent = () => (
  <FormLabel
    label={
      <span className={styles.savedOptionsLabel}>
        Saved Options
        <span className={styles.savedOptionsTooltipIcon}>
          <TooltipIcon
            id="saved-options-tooltip"
            icon={icons.circleQuestion}
            tooltip={tooltipText}
            placement="left"
        />
        </span>
      </span>
    }
  />
);
